import { ExportReportType } from '~/exportReport/exportReportType';
import { ExportReportPrintPageDriveTimePolygonComponent } from '~/exportReport/printPage/exportReportPrintPageDriveTimePolygon.component';
import { ExportReportPrintPageLocationComponent } from '~/exportReport/printPage/exportReportPrintPageLocation.component';
import { ExportReportPrintPagePolygonComponent } from '~/exportReport/printPage/exportReportPrintPagePolygon.component';
import { ExportReportPrintPageRadiusComponent } from '~/exportReport/printPage/exportReportPrintPageRadius.component';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';

export const ExportReportPrintPageContainer = () => {
  const exportReportState = useToolsStateExportReportSelector();

  if (!exportReportState.isActive) {
    return null;
  }

  if (exportReportState.params.type === ExportReportType.Location) {
    return (
      <ExportReportPrintPageLocationComponent
        params={exportReportState.params}
        template={exportReportState.settings.template}
      />
    );
  }

  if (exportReportState.params.type === ExportReportType.Radius) {
    return (
      <ExportReportPrintPageRadiusComponent
        params={exportReportState.params}
        template={exportReportState.settings.template}
      />
    );
  }

  if (exportReportState.params.type === ExportReportType.Polygon) {
    return (
      <ExportReportPrintPagePolygonComponent
        params={exportReportState.params}
        template={exportReportState.settings.template}
      />
    );
  }

  if (exportReportState.params.type === ExportReportType.DriveTimePolygon) {
    return (
      <ExportReportPrintPageDriveTimePolygonComponent
        params={exportReportState.params}
        template={exportReportState.settings.template}
      />
    );
  }

  return null;
};
